import React from 'react'
import { IBaseProps } from '@did/types'
import { GradientBg } from '@did/das-balance-components'
import { useDasBalanceContext } from '@did/das-app-context'
import { BaseCard, IconButton, Iconfont } from '@did/uikit'
import DidPointLogo from '@did/das-balance-assets/images/components/didpoint-logo.svg'
import { WithdrawList } from './WithdrawList'

export const WithdrawIndex: React.FC<IBaseProps> = () => {
  const { tt, router } = useDasBalanceContext()

  const data = [
    { didPoint: '100', source: 'System Allocation', action: 'Withdraw' },
    { didPoint: '200', source: 'User Contribution', action: 'Withdraw' }
  ]
  const onBack = () => {
    if (window.history.length === 2) {
      router.push('/credits')
      return
    }
    router.back?.()
  }

  return (
    <div className="max-w-5xl mx-auto px-3 sm:px-0 pt-3 z-0 relative">
      <GradientBg type="blue" />
      <div className="max-w-5xl w-full mt-11">
        <div className="w-24">
          <IconButton
            onClick={onBack}
            Icon={(props) => <Iconfont name="back" {...props} />}
          >
            {tt('Back')}
          </IconButton>
        </div>
      </div>
      <div className="flex flex-col items-center">
        <DidPointLogo className="w-[66px] h-[66px]" />
        <h2 className="mt-3 mb-8 text-2xl font-bold text-tip-font-color">
          {tt('Withdraw')}
        </h2>
      </div>
      <BaseCard className="mx-auto p-6 w-full sm:w-[520px] rounded-3xl">
        <h2 className="text-base font-semibold text-left mb-3">
          {tt('DIDPoint Withdrawal Rules')}
        </h2>
        <div className="text-tip-font-color mb-3 text-sm">
          {tt(
            'Withdrawal of DIDPoints will be refunded to the payment source for each top-up. The cryptocurrency exchange rate will be the latest at the time of your withdrawal.'
          )}
        </div>
      </BaseCard>
      <BaseCard className="mx-auto p-6 w-full sm:w-[520px] rounded-3xl mt-3">
        <h2 className="text-base font-bold pb-6">
          {tt('Choose which one to withdraw')}
        </h2>
        <WithdrawList className="" list={[]}></WithdrawList>
      </BaseCard>
    </div>
  )
}
